// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__EQj0r","errors":"Errors_errors__Fqv4n"};